exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alt-login {\n  clear: right;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 3rem 0 0;\n  text-align: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/login-module/login-page/login.component.scss
// module id = ../../../../../src/app/login-module/login-page/login.component.scss
// module chunks = main